import React from 'react'
import createIcon from '@/lib/create-icon'

export const CodeSVGIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6673 12L14.6673 8L10.6673 4M5.33398 4L1.33398 8L5.33398 12"
      stroke="currentColor"
      strokeOpacity="0.3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
